/* import __COLOCATED_TEMPLATE__ from './resend-idv-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();